var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedOurProgramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1109_1601)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 28C22.4399 28 15.3333 29.7867 15.3333 33.3333V36H36.6666V33.3333C36.6666 29.7867 29.5599 28 25.9999 28ZM17.9999 33.3333C18.2933 32.3733 22.4133 30.6667 25.9999 30.6667C29.5999 30.6667 33.7333 32.3867 33.9999 33.3333H17.9999ZM20.3199 20H20.6666C20.6666 22.9467 23.0533 25.3333 25.9999 25.3333C28.9466 25.3333 31.3333 22.9467 31.3333 20H31.6799C32.0399 20 32.3333 19.7067 32.3333 19.3467V19.32C32.3333 19.1467 32.2644 18.9805 32.1419 18.858C32.0194 18.7355 31.8532 18.6667 31.6799 18.6667H31.3333C31.3333 16.6933 30.2533 15 28.6666 14.0667V15.3333C28.6666 15.7067 28.3733 16 27.9999 16C27.6266 16 27.3333 15.7067 27.3333 15.3333V13.52C26.9066 13.4133 26.4666 13.3333 25.9999 13.3333C25.5333 13.3333 25.0933 13.4133 24.6666 13.52V15.3333C24.6666 15.7067 24.3733 16 23.9999 16C23.6266 16 23.3333 15.7067 23.3333 15.3333V14.0667C21.7466 15 20.6666 16.6933 20.6666 18.6667H20.3199C20.2341 18.6667 20.1492 18.6836 20.0699 18.7164C19.9906 18.7492 19.9186 18.7974 19.8579 18.858C19.7973 18.9187 19.7492 18.9907 19.7163 19.07C19.6835 19.1492 19.6666 19.2342 19.6666 19.32V19.36C19.6666 19.7067 19.9599 20 20.3199 20ZM28.6666 20C28.6666 21.4667 27.4666 22.6667 25.9999 22.6667C24.5333 22.6667 23.3333 21.4667 23.3333 20H28.6666ZM43.3066 16.3067L44.5466 15.2L43.5466 13.4667L41.9599 13.9867C41.7733 13.84 41.5599 13.72 41.3333 13.6267L40.9999 12H38.9999L38.6666 13.6267C38.4399 13.72 38.2266 13.84 38.0266 13.9867L36.4533 13.4667L35.4533 15.2L36.6933 16.3067C36.6666 16.5333 36.6666 16.7733 36.6933 17L35.4533 18.1333L36.4533 19.8667L38.0533 19.36C38.2266 19.4933 38.4266 19.6 38.6266 19.6933L38.9999 21.3333H40.9999L41.3599 19.7067C41.5733 19.6133 41.7599 19.5067 41.9466 19.3733L43.5333 19.88L44.5333 18.1467L43.2933 17.0133C43.3333 16.76 43.3199 16.5333 43.3066 16.3067ZM39.9999 18.3333C39.5579 18.3333 39.134 18.1577 38.8214 17.8452C38.5088 17.5326 38.3333 17.1087 38.3333 16.6667C38.3333 16.2246 38.5088 15.8007 38.8214 15.4882C39.134 15.1756 39.5579 15 39.9999 15C40.4419 15 40.8659 15.1756 41.1784 15.4882C41.491 15.8007 41.6666 16.2246 41.6666 16.6667C41.6666 17.1087 41.491 17.5326 41.1784 17.8452C40.8659 18.1577 40.4419 18.3333 39.9999 18.3333ZM39.8666 22.3867L38.7333 22.76C38.5999 22.6533 38.4533 22.5733 38.2933 22.5067L38.0533 21.3333H36.6266L36.3866 22.4933C36.2266 22.56 36.0666 22.6533 35.9333 22.7467L34.8133 22.3733L34.0933 23.6133L34.9733 24.4C34.9599 24.5733 34.9599 24.7333 34.9733 24.8933L34.0933 25.7067L34.8133 26.9467L35.9599 26.5867C36.0933 26.68 36.2266 26.76 36.3733 26.8267L36.6133 28H38.0399L38.2933 26.84C38.4399 26.7733 38.5866 26.6933 38.7199 26.6L39.8533 26.96L40.5733 25.72L39.6933 24.9067C39.7066 24.7333 39.7066 24.5733 39.6933 24.4133L40.5733 23.6267L39.8666 22.3867ZM37.3333 25.8533C36.6799 25.8533 36.1466 25.32 36.1466 24.6667C36.1466 24.0133 36.6799 23.48 37.3333 23.48C37.9866 23.48 38.5199 24.0133 38.5199 24.6667C38.5199 25.32 37.9866 25.8533 37.3333 25.8533Z",
    fill: "#EE6666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 47,
    rx: 11.5,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1109_1601",
    x: 0,
    y: 0,
    width: 64,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1109_1601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1109_1601",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedOurProgramIcon);
export default __webpack_public_path__ + "static/media/redOurProgramIcon.9c68fd2255d8f44f489273a4cbc3d36e.svg";
export { ForwardRef as ReactComponent };